<div class="container-fluid p-0 m-0 h-100">
  <div class="row p-0 m-0 h-100">
    <div class="col-2 d-flex p-0">
      <div class="templates-container position-relative w-100">
        <!-- LEFT PANEL -->
        <div class="text-container">
          <span class="text-title">List Templates</span>
        </div>
        <div class="search">
          <input
            type="text"
            id="searchTemplate"
            name="searchTemplate"
            [(ngModel)]="search"
            [placeholder]="'Search...'"
            class="input-app input-search"
            (ngModelChange)="searchTemplates($event)"
          />
        </div>
        <div class="cards" id="field-card-container">
          
        </div>
      </div>
    </div>

    <div class="col-10 d-flex p-0 justify-content-center">
      <div class="position-relative w-100">
        <!-- MAIN  -->
        <div class="general">          
          <!-- BUTTONS -->    
          <div class="buttons">
            <button [ngClass]="{'mg-button-selected': isPreview}" [disabled]="!templateSelected"
              (click)="previewLayout()" class="btn-style flex justify-content-center align-items-center me-1">
              <span [ngClass]="{'mg-button-icon-selected': isPreview}" class="material-symbols-outlined icon-style">
                visibility
              </span>
              <span [ngClass]="{'mg-button-icon-selected': isPreview}" class="text-sm">Preview</span>
            </button>           
            <button (click)="addTemplate()" class="btn-style flex justify-content-center align-items-center me-1">
              <span class="material-symbols-outlined icon-style">
                note_add
              </span>
              <span class="text-sm">Template</span>
            </button>            
            <!-- <button *ngIf="changeDetected" (click)="save()" [ngClass]="{ changes: changeDetected }" class="btn-style flex justify-content-center align-items-center me-1">
              <span class="material-symbols-outlined icon-style">
                save
              </span>
              <span class="text-sm">Save</span>
            </button>
            <button *ngIf="changeDetected" (click)="cancelEditLayout()" class="btn-style flex justify-content-center align-items-center me-1">
              <span class="material-symbols-outlined icon-style">
                cancel
              </span>
              <span class="text-sm">Cancel</span>
            </button>             -->
            <!-- <button style="margin-left: auto;" class="btn-style flex justify-content-center align-items-center me-1">
              <span class="material-symbols-outlined icon-style">
                dns
              </span>
              <span class="text-sm">Add Field</span>
            </button> -->
          </div>
        </div>
            
        <div class="container-body">
          <div class="mg-no-page-container" *ngIf="!templateSelected">
            <!--  <mat-icon class="">list_alt_add</mat-icon> -->
            <span class="mg-no-page-text">No template selected. Please create one to load Preview</span>
          </div>
          <!-- NO PAGES -->
          <div class="mg-no-page-container" *ngIf="!currentPage || editedLayout.length == 0">
            <!--  <mat-icon class="">list_alt_add</mat-icon> -->
            <span class="mg-no-page-text">No pages found. Please create one in Layout seccion</span>
          </div>

          <!-- PAGES -->
          <div class="mg-page-wrapper" [ngClass]="{'hide': !this.isPreview}">
            <div class="mg-page-container" *ngIf="currentPage && editedLayout">
              <ng-container *ngFor="let page of editedLayout; index as i">
                <div class="mg-page-text-container">
                  <span (click)="setCurrentPage(page.id, i)" class="mg-page-title" [ngClass]="{'mg-page-selected': this.currentPage.id === page.id}">{{page.name}} ({{i+1}})</span>
                </div>
                <div *ngIf="i < editedLayout.length - 1" class="mg-page-text-container">
                  <span class="mg-page-title">|</span>
                </div>
              </ng-container>
            </div>
          </div>

          <!-- PREVIEW  -->
          <div [ngClass]="{'hide': !this.isPreview}">
            <mng-fill-form [inputProperties]="formOptions"></mng-fill-form>
          </div>

        </div>
          
      </div>

    </div>
  </div>  

</div>